module.exports = __webpack_public_path__ + "media/careers/careers_bg--overlay4-e3f8e322.png";